import Raven from 'raven-js';
export function captureException(exception, fingerprint, options = {}) {
  Raven.captureException(exception, Object.assign({
    fingerprint
  }, options));
}